export default "__VITE_ASSET__BwTipX_S__"